import { jsx as _jsx } from "react/jsx-runtime";
import * as Utils from '_utils';
import * as Styles from './SimpleBlocks.module.scss';
export var BlockVariant;
(function (BlockVariant) {
    BlockVariant[BlockVariant["Left"] = 0] = "Left";
    BlockVariant[BlockVariant["Right"] = 1] = "Right";
    BlockVariant[BlockVariant["Empty"] = 2] = "Empty";
    BlockVariant[BlockVariant["Default"] = 3] = "Default";
    BlockVariant[BlockVariant["Nested"] = 4] = "Nested";
})(BlockVariant || (BlockVariant = {}));
export var BlockSpan;
(function (BlockSpan) {
    BlockSpan[BlockSpan["Default"] = 0] = "Default";
    BlockSpan[BlockSpan["AllRows"] = 1] = "AllRows";
    BlockSpan[BlockSpan["AllColumns"] = 2] = "AllColumns";
})(BlockSpan || (BlockSpan = {}));
export var BlockContentAligh;
(function (BlockContentAligh) {
    BlockContentAligh[BlockContentAligh["Left"] = 0] = "Left";
    BlockContentAligh[BlockContentAligh["Center"] = 1] = "Center";
    BlockContentAligh[BlockContentAligh["Right"] = 2] = "Right";
})(BlockContentAligh || (BlockContentAligh = {}));
export var BlockSize;
(function (BlockSize) {
    BlockSize[BlockSize["Default"] = 0] = "Default";
    BlockSize[BlockSize["Full"] = 1] = "Full";
})(BlockSize || (BlockSize = {}));
export var GridType;
(function (GridType) {
    GridType[GridType["Properties"] = 0] = "Properties";
})(GridType || (GridType = {}));
export function Block(props) {
    const classes = Utils.classNames({
        [Styles.block]: true,
        [Styles.variant_left]: props.variant === BlockVariant.Left,
        [Styles.variant_right]: props.variant === BlockVariant.Right,
        [Styles.variant_empty]: props.variant === BlockVariant.Empty,
        [Styles.variant_nested]: props.variant === BlockVariant.Nested,
        [Styles.block_span_all_rows]: props.span === BlockSpan.AllRows,
        [Styles.block_span_all_columns]: props.span === BlockSpan.AllColumns,
        [Styles.content_align_left]: props.contentAlign === BlockContentAligh.Left,
        [Styles.content_align_center]: props.contentAlign === BlockContentAligh.Center,
        [Styles.content_align_right]: props.contentAlign === BlockContentAligh.Right,
        [Styles.block_size_full]: props.size === BlockSize.Full,
    });
    return _jsx("div", { className: classes, children: props.children });
}
export function BlockRow(props) {
    const classes = Utils.classNames({
        [Styles.row]: true,
    });
    return _jsx("div", { className: classes, children: props.children });
}
export function BlockGrid(props) {
    const classes = Utils.classNames({
        [Styles.grid]: true,
        [Styles.grid_type_properties]: props.type === GridType.Properties,
    });
    return _jsx("div", { className: classes, children: props.children });
}
